import { makeStyles } from '@material-ui/core'
import palette from 'theme/palette'

const styles = makeStyles((theme) => ({
  chatHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingInline: theme.spacing(2),
    marginInline: -theme.spacing(2),
    borderBottom: `1px solid ${palette.divider}`,
  },
  daiLogo: {
    width: '80px',
    height: 'auto',
  },
  chatIntroductionFirstMessage: {
    color: '#2883BF',
  },
  previewChip: {
    marginBottom: -3,
    color: palette.dai.shinyBlue,
    fontWeight: 'bold',
  },
}))

export default styles
